/// <reference types='googlemaps' />
import {
  Component,
  Input,
  OnChanges,
  AfterViewInit,
  ElementRef
} from '@angular/core';
import { LazyloadService } from '../../lazyload.service';


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.less']
})
export class MapComponent implements OnChanges, AfterViewInit {
  @Input() mapdata: object;
  $map: any;
  active = null;
  constructor(private elRef: ElementRef, private lazyload: LazyloadService) { }

  ngAfterViewInit() {
    this.$map = this.elRef.nativeElement.querySelector('#rpd-covid19-map');
  }

  ngOnChanges(changes: any) {
    if (changes.mapdata.currentValue && this.$map) {
      this.startMap(this.mapdata);
    }
  }


  startMap(data) {
    const gmap = new google.maps.Map(this.$map, {
      streetViewControl: false,
      center : {
        lat: 0,
        lng: 0
      },
      zoom : 3,
      styles: [{elementType:'geometry',stylers:[{color:'#f5f5f5'}]},{elementType:'labels.icon',stylers:[{'visibility':'off'}]},{elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f5f5'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#bdbdbd'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},{featureType:'road.arterial',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#dadada'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#c9c9c9'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]}]

    });
    const popup = new window.google.maps.InfoWindow();
    data.forEach((element, key) => {
      const marker = new google.maps.Marker({
        position: {
          lat: element.location.lat,
          lng: element.location.lng,
        },
        map: gmap,
        icon: 'assets/icon.png',
      });

      marker.addListener('click', () => {
        popup.setContent( this.getInfo(element));
        popup.open(gmap, marker);
      });
    });

  }

  getInfo(info) {
    return `<div>
    <p><strong>${info.provincestate} - ${info.countryregion}</strong> </p>
          <p> Confirmed: ${info.confirmed} </p>
          <p> Deaths: ${info.deaths}</p>
          <p> Recovered: ${info.recovered}</p>
          </div>
    </div>`;
  }

}
